import { Injectable, inject } from '@angular/core';
import { Globals } from '../../globals';

@Injectable({
  providedIn: 'root',
})
export class ClientVersionService {
  private readonly globals = inject(Globals);


  getVersion() {
    return this.globals.version;
  }
}
